import React, { useEffect } from 'react';
import { setTitle } from '../utils/environment';

const Terms = () => {
  useEffect(() => setTitle('Terms of Service'), []);

  const effectiveDate = '2025-08-11';

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white shadow rounded-2xl p-8 md:p-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Effective date: {effectiveDate}</p>

        <div className="prose prose-gray max-w-none">
          <p>
            These Terms of Service (&quot;Terms&quot;) govern your access to and use of Read It Never (the &quot;Service&quot;). By
            using the Service, you agree to be bound by these Terms.
          </p>

          <h2>1. Overview</h2>
          <p>
            Read It Never helps you save articles and generate summaries using AI. You are responsible for how you use
            the Service and any content you submit.
          </p>

          <h2>2. Eligibility</h2>
          <p>You must be at least 13 years old to use the Service.</p>

          <h2>3. Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and for all
            activities that occur under your account.
          </p>

          <h2>4. Acceptable Use</h2>
          <ul>
            <li>Do not violate any laws or third-party rights.</li>
            <li>Do not attempt to abuse, overload, or disrupt the Service.</li>
            <li>Do not upload malicious code or content.</li>
          </ul>

          <h2>5. Content and IP</h2>
          <p>
            You retain ownership of content you submit. By submitting content, you grant us a non-exclusive license to
            process it for the purpose of providing the Service. Read It Never and its logos are our trademarks.
          </p>

          <h2>6. AI-Generated Output</h2>
          <p>
            Summaries may contain inaccuracies. Use discretion and verify important information. We provide the Service
            &quot;as is&quot; without warranties.
          </p>

          <h2>7. Privacy</h2>
          <p>
            Our <a className="text-primary-600 hover:text-primary-500" href="/#/privacy">Privacy Policy</a> explains
            how we handle your data.
          </p>

          <h2>8. Termination</h2>
          <p>
            We may suspend or terminate your access if you violate these Terms or misuse the Service.
          </p>

          <h2>9. Disclaimers & Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, we disclaim all warranties and will not be liable for indirect,
            incidental, or consequential damages arising from your use of the Service.
          </p>

          <h2>10. Changes</h2>
          <p>
            We may update these Terms from time to time. Material changes will be announced via the Service. Continued
            use after changes indicates acceptance.
          </p>

          <h2>11. Contact</h2>
          <p>
            Questions? Contact us at <a href="mailto:support@readitnever.xyz">support@readitnever.xyz</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;


